module.exports = __webpack_public_path__ + "images/985e17716ff2188abdef578b786eebc1.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/user-icon.svg
// module id = 830
// module chunks = 0